import { useFeatureFlagEnabled } from 'posthog-js/react';

/**
 * Global ops kill switch (100% rollout, no targeting), like
 * maintenance_mode_v1: turn it on in PostHog to stop new accounts. Fails open
 * (undefined while loading / blocked → sign-ups allowed). UI-only: for a hard
 * stop that also blocks direct Clerk API calls, set Clerk's sign-up mode to
 * Restricted.
 */
export const SIGNUPS_PAUSED_FLAG = 'signups_paused_v1';

export const useSignupsPaused = () =>
  useFeatureFlagEnabled(SIGNUPS_PAUSED_FLAG) === true;
